import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import OPlaceholder from "../../../../../Components/OElements/OPlaceholder";
import CardWithError from "../../../../../Components/Common/CardWithError";
import CardWithoutData from "../../../../../Components/Common/CardWithoutData";
import { getFuelSupplySummaryByMonth } from "../../../../../slices/fuelSupply/thunk";
import ReactApexChart from "react-apexcharts";

const FuelSupplyMonth = ({ title, height }) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.FuelSupply,
        result => ({
            data: result.itemFuelSupplyMonth,
            isLoading: result.isLoading,
            isSuccess: result.isSuccess,
            isError: result.isError,
        })
    );

    const { data, isLoading, isSuccess, isError } = useSelector(selector);

    useEffect(() => {
        dispatch(getFuelSupplySummaryByMonth());
    }, [dispatch]);

    console.log(data);

    // Preparación de datos para el gráfico
    const seriesChart = [];
    const labelsChart = [...new Set(data?.detail?.map(item => item.month_name_short))] || [];

    const colorsMap = {
        IN: "#008FFB",
        OUT: "#FF4560"
    };

    data?.detail?.forEach(item => {
        const fuelType = item.fuel_type?.trim() || "Unknown";
        const direction = item.direction?.trim() || "Unknown";

        // Busca una serie existente basada en las propiedades fuelType y direction
        const existingSeries = seriesChart.find(
            serie => serie.fuelType === fuelType && serie.direction === direction
        );

        if (existingSeries) {
            // Si existe, agrega el nuevo valor al arreglo data
            existingSeries.data.push(item[direction]);
        } else {
            // Si no existe, crea una nueva serie con esas propiedades
            seriesChart.push({
                name: `${fuelType} ${direction}`,
                fuelType,
                direction,
                color: colorsMap[direction] || "#CCCCCC",
                data: [item[direction]]
            });
        }
    });

    // Extraer meses únicos (categorías del eje X)
    const categories = [...new Set(data.map(item => item.month_name_short))];

    // Extraer tipos de combustible únicos
    const fuelTypes = [...new Set(data.map(item => item.fuel_type))];

    // Generar series con formato de "group"
    const series = fuelTypes.flatMap(fuelType => [
        {
            name: `Entradas (${fuelType})`,
            group: fuelType,
            color: '#80c7fd',
            data: categories.map(month => {
                const entry = data.find(item => item.month_name_short === month && item.fuel_type === fuelType);
                return entry ? entry.IN : 0;
            }),
            unit_measurement: data.find(item => item.fuel_type === fuelType)?.unit_measurement,
        },
        {
            name: `Salidas (${fuelType})`,
            group: fuelType,
            color: '#008FFB',
            data: categories.map(month => {
                const entry = data.find(item => item.month_name_short === month && item.fuel_type === fuelType);
                return entry ? entry.OUT : 0;
            }),
            unit_measurement: data.find(item => item.fuel_type === fuelType)?.unit_measurement,
        },
    ]);

    const maxYValue = Math.max(
        ...series.flatMap(serie => serie.data)
    );

    console.log(data)
    console.log(categories)
    console.log(series)


    const options = {
        chart: {
            type: 'bar',
            height: 300,
            stacked: true
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '12px', // Reduce el tamaño del texto si es necesario
            },
            formatter: function (val, opts) {
                const unit = opts.w.config.series[opts.seriesIndex]?.unit_measurement || "unidades";
                return `${val.toLocaleString()} ${unit}`;
            },
            offsetY: -10, // Ajusta la posición vertical de las etiquetas
        },
        plotOptions: {
            bar: {
                horizontal: false,
            },
        },
        xaxis: {
            categories: categories,
        },
        yaxis: {
            max: maxYValue,
            labels: {
                formatter: function (val) {
                    return val.toLocaleString(); // Formato con separadores de miles
                },
            },
        },
        legend: {
            position: 'bottom'
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (val, opts) {
                    const unit = opts.w.config.series[opts.seriesIndex]?.unit_measurement || "unidades";
                    return `${val.toLocaleString()} ${unit}`;
                },
            },
        },
    };


    // if (isLoading) {
    //     return <OPlaceholder />;
    // }

    // if (isError) {
    //     return <CardWithError title={title} />;
    // }

    if (isSuccess && data) {
        return (
            <React.Fragment>
                <Card className='card-height-100'>
                    <CardHeader className='p-2 align-items-center d-flex'>
                        <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
                    </CardHeader>
                    <CardBody className="p-2">
                        <div className="w-100">
                            <ReactApexChart
                                dir="ltr"
                                options={options}
                                series={series}
                                type="bar"
                                height={height}
                                className="apex-charts"
                            />
                        </div>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }

    // return <CardWithoutData title={title} />;
};

export default FuelSupplyMonth;
